module.exports = __webpack_public_path__ + "static/img/sisda.5217aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/work/sisda.png
// module id = JkyL
// module chunks = 0